var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import Grid from '@m4b-design/grid';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import FormItem from '../form-item';
import { SearchAndFilterContext } from './context';
export function SearchItems(props) {
    var config = useContext(SearchAndFilterContext);
    var _a = props.list, _list = _a === void 0 ? [] : _a, _b = props.containerProps, containerProps = _b === void 0 ? {} : _b;
    var list = _list.filter(function (v) { return (config.moreFilter.visible ? true : !v.showInMoreFilter); });
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-search-and-filter-search-items");
    return (React.createElement(Grid, __assign({ colGap: 16, rowGap: 8 }, containerProps, { className: cx(prefixCls, containerProps.className) }), list.map(function (itemProps, i) {
        var _a;
        var field = itemProps.field, _b = itemProps.formItemProps, formItemProps = _b === void 0 ? {} : _b, _c = itemProps.containerProps, containerProps = _c === void 0 ? {} : _c, children = itemProps.children, label = itemProps.label;
        return (React.createElement(Grid.GridItem, __assign({ key: i }, containerProps),
            label && React.createElement("div", { className: cx("".concat(prefixCls, "-label")) }, label),
            React.createElement(FormItem, __assign({ field: field, showLabel: false, wrapperCol: { span: 24 } }, formItemProps, { style: __assign({ marginBottom: 0 }, ((_a = formItemProps === null || formItemProps === void 0 ? void 0 : formItemProps.style) !== null && _a !== void 0 ? _a : {})) }), children)));
    })));
}
